import addRoute from '@/router/add-route';

const Tags = () => import('@/modules/tags/tags.vue');


const tags = [
    addRoute({
        name: 'tags',
        path: '/tags',
        component: Tags,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default tags;
